import { jsx as d, jsxs as C, Fragment as B } from "react/jsx-runtime";
import S, { useRef as p, useMemo as w, useEffect as v, useState as A, createElement as N } from "react";
import { MDCDialogFoundation as g } from "@material/dialog";
import { useFoundation as I, matches as R, closest as U, triggerWindowResize as k, focusTrapFactory as L, createComponent as D, useClassNames as E, PortalChild as P, Tag as O, ArrayEmitter as K, randomId as x } from "@rmwc/base";
import { Button as q } from "@rmwc/button";
import { TextField as M } from "@rmwc/textfield";
const j = (e) => e.scrollHeight > e.offsetHeight, $ = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e == null || e.forEach((r) => t.add(r.offsetTop)), t.size > 1;
}, z = (e) => {
  const t = p(), r = p(null), o = p(null), i = p(null), { foundation: s, ...m } = I({
    props: e,
    elements: {
      rootEl: !0
    },
    foundation: ({ rootEl: a, emit: l, getProps: b }) => new g({
      addClass: (n) => a.addClass(n),
      removeClass: (n) => a.removeClass(n),
      hasClass: (n) => a.hasClass(n),
      addBodyClass: (n) => document.body && document.body.classList.add(n),
      removeBodyClass: (n) => document.body && document.body.classList.remove(n),
      eventTargetMatches: (n, y) => R(n, y),
      trapFocus: () => {
        var n;
        try {
          (n = t.current) == null || n.trapFocus();
        } catch {
        }
      },
      releaseFocus: () => {
        var n;
        return (n = t.current) == null ? void 0 : n.releaseFocus();
      },
      isContentScrollable: () => !!i.current && j(i.current),
      areButtonsStacked: () => $(o.current),
      getActionFromEvent: (n) => {
        const y = U(
          n.target,
          `[${g.strings.ACTION_ATTRIBUTE}]`
        );
        return (y == null ? void 0 : y.getAttribute(
          g.strings.ACTION_ATTRIBUTE
        )) || null;
      },
      clickDefaultButton: () => {
        var n;
        (n = r.current) == null || n.click();
      },
      reverseButtons: () => {
        var n, y;
        (n = o.current) == null || n.reverse(), (y = o.current) == null || y.forEach(
          (h) => h.parentElement && h.parentElement.appendChild(h)
        );
      },
      notifyOpening: () => l("onOpen", {}),
      notifyOpened: () => {
        l("onOpened", {}), k();
      },
      notifyClosing: (n) => l("onClose", n ? { action: n } : {}),
      notifyClosed: (n) => l("onClosed", n ? { action: n } : {}),
      getInitialFocusEl: () => document.querySelector(
        `[${g.strings.INITIAL_FOCUS_ATTRIBUTE}]`
      )
    })
  }), { rootEl: c } = m, u = w(() => {
    const a = s.handleDocumentKeydown.bind(s);
    return (l) => {
      if (!(l.key === "Escape" && e.preventOutsideDismiss))
        return a(l);
    };
  }, [s, e.preventOutsideDismiss]);
  v(() => {
    var a;
    r.current = c.ref && c.ref.querySelector(
      `[${g.strings.BUTTON_DEFAULT_ATTRIBUTE}]`
    ) || null, o.current = c.ref && [].slice.call(
      c.ref.querySelectorAll(g.strings.BUTTON_SELECTOR)
    ), i.current = ((a = c.ref) == null ? void 0 : a.querySelector(g.strings.CONTENT_SELECTOR)) || null;
  }, [c.ref]), v(() => {
    const a = c.ref && c.ref.querySelector(
      g.strings.SURFACE_SELECTOR
    );
    a && (t.current = L(a, {
      initialFocusEl: r.current || void 0
    }));
  }, [c.ref]), v(() => (e.open ? s.isOpen() || (document.addEventListener("keydown", u), s.open()) : s.isOpen() && (document.removeEventListener("keydown", u), s.close()), () => {
    document.removeEventListener("keydown", u);
  }), [e.open, s, u]);
  const T = (a) => {
    var l;
    return (l = e.onClick) == null || l.call(e, a), s.handleClick(a);
  }, f = (a) => {
    var l;
    return (l = e.onKeyDown) == null || l.call(e, a), s.handleKeydown(a);
  };
  return c.setProp("onClick", T, !0), c.setProp("onKeyDown", f, !0), { foundation: s, ...m };
}, H = D(function(t, r) {
  const { rootEl: o } = z(t), i = E(t, ["mdc-dialog"]), {
    children: s,
    open: m,
    onOpen: c,
    onOpened: u,
    onClose: T,
    onClosed: f,
    preventOutsideDismiss: a,
    foundationRef: l,
    renderToPortal: b,
    "aria-labelledby": n,
    "aria-describedby": y,
    ...h
  } = t;
  return /* @__PURE__ */ d(P, { renderTo: b, children: /* @__PURE__ */ C(O, { ...h, element: o, className: i, ref: r, children: [
    /* @__PURE__ */ d("div", { className: "mdc-dialog__container", children: /* @__PURE__ */ d(
      "div",
      {
        className: "mdc-dialog__surface",
        role: "alertdialog",
        "aria-modal": !0,
        "aria-labelledby": n,
        "aria-describedby": y,
        children: s
      }
    ) }),
    /* @__PURE__ */ d(V, { disableInteraction: a })
  ] }) });
}), Q = D(
  function({
    title: t,
    header: r,
    body: o,
    footer: i,
    acceptLabel: s = "Accept",
    cancelLabel: m = "Cancel",
    children: c,
    open: u,
    ...T
  }, f) {
    return /* @__PURE__ */ C(H, { open: u, ...T, ref: f, children: [
      (!!t || !!r) && /* @__PURE__ */ C(W, { children: [
        !!t && t,
        !!r && r
      ] }),
      (!!o || c) && /* @__PURE__ */ C(Y, { children: [
        o,
        c
      ] }),
      (!!m || !!s || !!i) && /* @__PURE__ */ C(G, { children: [
        !!i && i,
        !!m && /* @__PURE__ */ d(F, { action: "close", children: m }),
        !!s && /* @__PURE__ */ d(F, { action: "accept", isDefaultAction: !0, children: s })
      ] })
    ] });
  }
), V = S.memo(function({
  disableInteraction: t
}) {
  return /* @__PURE__ */ d("div", { className: "mdc-dialog__scrim", style: t ? { pointerEvents: "none" } : {} });
}), W = D(
  function(t, r) {
    const o = E(t, ["mdc-dialog__title"]);
    return /* @__PURE__ */ d(O, { tag: "h2", ...t, ref: r, className: o });
  }
), Y = D(
  function(t, r) {
    const o = E(t, ["mdc-dialog__content"]);
    return /* @__PURE__ */ d(O, { ...t, ref: r, className: o });
  }
), G = D(
  function(t, r) {
    const o = E(t, ["mdc-dialog__actions"]);
    return /* @__PURE__ */ d(O, { ...t, ref: r, className: o });
  }
), F = D(
  function(t, r) {
    const o = E(t, ["mdc-dialog__button"]), { action: i = "accept", isDefaultAction: s, ...m } = t, c = s ? { [g.strings.BUTTON_DEFAULT_ATTRIBUTE]: !0 } : {};
    return /* @__PURE__ */ d(
      q,
      {
        ...m,
        ...c,
        ref: r,
        className: o,
        "data-mdc-dialog-action": i
      }
    );
  }
);
function ae({
  dialogs: e,
  ...t
}) {
  const [, r] = A(0), [o, i] = A(
    {}
  );
  v(() => {
    const c = () => r((u) => u + 1);
    return e.on("change", c), () => {
      e.off("change", c);
    };
  }, [e]);
  const s = (c, u) => {
    i({
      ...o,
      [u.id]: !0
    }), u.resolve(c), setTimeout(() => {
      const T = e.array.indexOf(u);
      ~T && e.array.splice(T, 1);
      const f = { ...o };
      delete f[u.id], i(f);
    }, 150);
  };
  let m = !1;
  return /* @__PURE__ */ d(B, { children: e.array.map((c) => {
    const { resolve: u, reject: T, id: f, inputProps: a, ...l } = c, b = /* @__PURE__ */ N(
      Q,
      {
        ...t,
        ...l,
        key: f,
        open: !o[f] && !m,
        onClose: (n) => {
          s(n, c), c.onClose && c.onClose(n);
        }
      }
    );
    return o[f] || (m = !0), b;
  }) });
}
const _ = (e, t) => (r) => new Promise((o, i) => {
  const s = e({ id: x(), ...r, resolve: o, reject: i });
  t.push(s);
});
function J({
  body: e,
  inputProps: t,
  apiRef: r
}) {
  const [o, i] = A("");
  return v(() => {
    r(() => o);
  }, [r, o]), /* @__PURE__ */ C("div", { children: [
    !!e && /* @__PURE__ */ d("div", { style: { marginBottom: "1rem" }, children: e }),
    /* @__PURE__ */ d(
      M,
      {
        style: { width: "100%" },
        autoFocus: !0,
        ...t,
        value: o,
        onChange: (s) => {
          i(s.currentTarget.value);
        }
      }
    )
  ] });
}
const X = (e) => {
  let t = () => "";
  const r = /* @__PURE__ */ d(
    J,
    {
      body: e.body,
      inputProps: e.inputProps,
      apiRef: (o) => t = o
    }
  );
  return {
    title: "Prompt",
    ...e,
    body: r,
    resolve: (o) => {
      e.resolve(o.detail.action === "accept" ? t() : null), t = void 0;
    }
  };
}, Z = (e) => ({
  title: "Alert",
  body: "You have been alerted!",
  acceptLabel: "OK",
  cancelLabel: null,
  ...e,
  resolve: (t) => e.resolve(t.detail.action)
}), ee = (e) => ({
  title: "Confirm",
  body: "Are you sure you want do that?",
  acceptLabel: "OK",
  cancelLabel: "Cancel",
  ...e,
  resolve: (t) => e.resolve(t.detail.action === "accept")
}), ie = () => {
  const e = new K();
  return {
    dialogs: e,
    alert: _(Z, e),
    confirm: _(ee, e),
    prompt: _(X, e)
  };
};
export {
  H as Dialog,
  G as DialogActions,
  F as DialogButton,
  Y as DialogContent,
  ae as DialogQueue,
  W as DialogTitle,
  Q as SimpleDialog,
  ie as createDialogQueue
};
